import merge from 'deepmerge';
import React from 'react';
import { ProvideMediaMatchers } from 'react-media-match';
import { StyleSheetManager } from 'styled-components';
import CssStore from '../CssStore';
import GlobalHelmetProvider from '../HelmetProvider';
import IntlProvider, { defaultLocale, getUserLocale, sanitizeLocale, } from '../IntlProvider';
import NotificationProvider from '../Notification/NotificationProvider';
import { ThemeProvider } from '../ThemeProvider';
export var ComponentProvider = function (_a) {
    var children = _a.children, _b = _a.fallbackLocale, fallbackLocale = _b === void 0 ? defaultLocale : _b, locale = _a.locale, mediaOverwrite = _a.mediaOverwrite, _c = _a.themeOverwrite, themeOverwrite = _c === void 0 ? {} : _c, theme = _a.theme, _d = _a.messages, messages = _d === void 0 ? {} : _d, injectLocaleToHtml = _a.injectLocaleToHtml;
    // The require call will be resolved downstream with the help of val-loader
    // eslint-disable-next-line
    var companyTheme = typeof theme !== 'undefined' ? theme : require('../theme/getTheme');
    var finalTheme = merge(companyTheme, themeOverwrite);
    var sanitizedLocale = locale ? sanitizeLocale(locale) : getUserLocale(fallbackLocale);
    var page = (React.createElement(CssStore, null,
        React.createElement(IntlProvider, { locale: sanitizedLocale, messages: messages[sanitizedLocale] || messages[fallbackLocale] || {} },
            React.createElement(ThemeProvider, { theme: finalTheme },
                React.createElement(NotificationProvider, null,
                    React.createElement(GlobalHelmetProvider, { locale: sanitizedLocale, injectLocaleToHtml: injectLocaleToHtml }, mediaOverwrite ? (React.createElement(ProvideMediaMatchers, { state: {
                            mobile: mediaOverwrite === 'mobile',
                            tablet: mediaOverwrite === 'tablet',
                            desktop: mediaOverwrite === 'desktop',
                        } }, children)) : (React.createElement(ProvideMediaMatchers, null, children))))))));
    // short ?-Syntax doesn't work here for some reason. So we do it the old way.
    if (typeof window !== 'undefined' &&
        window.navigator &&
        window.navigator.userAgent.indexOf('prerenderChrome') > -1) {
        return React.createElement(StyleSheetManager, { disableCSSOMInjection: true }, page);
    }
    return page;
};
export default ComponentProvider;
//# sourceMappingURL=index.js.map